import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { FinanceApiService, FundRecord } from './finance-api.service';

@Component({
  standalone: true,
  selector: 'ain-finance-control-center-funds',
  imports: [AinPageComponent, FormsModule, TableModule, ButtonModule, InputTextModule, RouterLink],
  providers: [MessageService],
  template: `
    <ain-page title="Funds" description="Create and review fund master data">
      <div class="toolbar">
        <a class="back-link" [routerLink]="['/financial/control-center']">Back to Control Center</a>
      </div>

      <div class="create-row">
        <input pInputText [(ngModel)]="fundCode" placeholder="Code" />
        <input pInputText [(ngModel)]="fundName" placeholder="Name" />
        <button pButton type="button" label="Create" (click)="createFund()"></button>
      </div>

      <p-table [value]="funds()">
        <ng-template pTemplate="header">
          <tr>
            <th>Code</th>
            <th>Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.code }}</td>
            <td>{{ row.name }}</td>
          </tr>
        </ng-template>
      </p-table>
    </ain-page>
  `,
  styles: [`
    .toolbar { margin-bottom: 12px; }
    .back-link { color: var(--ain-color-primary); font-weight: 600; text-decoration: none; }
    .create-row { margin-bottom: 12px; display: flex; gap: 8px; flex-wrap: wrap; }
  `]
})
export class FinanceControlCenterFundsComponent implements OnInit {
  private readonly api = inject(FinanceApiService);
  private readonly messages = inject(MessageService);

  readonly funds = signal<FundRecord[]>([]);
  fundCode = '';
  fundName = '';

  ngOnInit(): void {
    this.api.listFunds().subscribe({ next: rows => this.funds.set(rows) });
  }

  createFund(): void {
    const code = this.fundCode.trim();
    const name = this.fundName.trim();
    if (!code || !name) {
      return;
    }

    this.api.createFund({ code, name }).subscribe({
      next: created => {
        this.funds.update(rows => [created, ...rows]);
        this.fundCode = '';
        this.fundName = '';
      },
      error: () => this.messages.add({ severity: 'error', summary: 'Fund creation failed' })
    });
  }
}
